import React from "react";

const SavingsRiskInformation = ({ details, life_cover, covers, death_claim }) => {
  return (
    <div className='w-100'>
      {/* <p className='fw-bolder'>{life_cover?.life_cover_name}</p> */}
      {/* {details?.map((data, i) => (
        <div className='shadow-sm px-2 py-1 mb-2 w-100 text-capitalize' key={i}>
          {data?.cover_name}
        </div>
      ))} */}
      <div>
        <label htmlFor='covers' className='form-label shadow-lg p-1'>
          <span className='fw-bold'>Life Cover Name: </span>
          {life_cover?.life_cover_name}
        </label> <br />
        <label htmlFor='covers' className='form-label shadow-lg p-1 mt-2'>
          <span className='fw-bold'>Death Benefit Claim Name: </span>
          {death_claim?.life_cover_claim_name === "multiple" && (
            <>
              <span>Multiple</span>
            </>
          )}
          {death_claim?.life_cover_claim_name === "assumed" && (
            <>
              <span>Assumed Sum Assured</span>
            </>
          )}
          {death_claim?.life_cover_claim_name === "guaranteed" && (
            <>
              <span>Guaranteed Sum Assured</span>
            </>
          )}
        </label> <br />
        {death_claim?.life_cover_claim_name === "guaranteed" && <label className='form-label shadow-lg p-1 mt-2'>
          <span className='fw-bold'>Guaranteed Type: </span>
          {death_claim?.assumed_garranty_type === "fixed" && (
            <>
              <span>Fixed</span>
            </>
          )}
          {death_claim?.assumed_garranty_type === "range" && (
            <>
              <span>Range</span>
            </>
          )}
        </label>} {death_claim?.life_cover_claim_name === "guaranteed" && <br />}
        {death_claim?.life_cover_claim_name === "multiple" && <label className='form-label shadow-lg p-1 mt-2'>
          <span className='fw-bold'>Death Benefit Amount: </span>
          {JSON.parse(death_claim?.multiple_value)?.map((item, i) => (
                        <span
                          className='bg-primary text-light fs-6 text-capitalize'
                          style={{ padding: "4px", margin: "0px 4px" }}
                          key={i}
                        >
                          {item}
                        </span>
                    ))}
        </label>} {death_claim?.life_cover_claim_name === "multiple" &&<br />}
        {death_claim?.life_cover_claim_name === "guaranteed" && 
          <div className="mt-2">
            {death_claim?.assumed_garranty_type === "fixed" && <label className='form-label shadow-lg p-1 col-md-5'>
              <span className='fw-bold'>Death Benefit Amount: </span>
              <span className="">{death_claim?.assumed_garranty_value}</span>
            </label>}
            {death_claim?.assumed_garranty_type === "range" && <label htmlFor='covers' className='form-label shadow-lg p-1'>
              <span className='fw-bold'>Guaranteed Minimum Amount: </span>
              {death_claim?.assumed_garranty_minimum}
              <span className='fw-bold ms-2'>Guaranteed Maximum Amount: </span>
              {death_claim?.assumed_garranty_maximum}
            </label>}
          </div> 
        } {death_claim?.life_cover_claim_name === "guaranteed" && <br />}
        {details?.length ? (
          <table className='table table-centered table-striped nowrap w-100 no-footer'>
            <thead>
              <tr>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "140.8px" }}
                  aria-label='Customer: activate to sort column ascending'
                >
                  Other Cover
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "5.8px" }}
                  aria-label='Customer: activate to sort column ascending'
                >
                  Rate(%)
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "140.8px" }}
                  aria-label='Phone: activate to sort column ascending'
                >
                  sum Assured
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "147.8px" }}
                >
                  Premium
                </th>
                <th
                  className='sorting'
                  tabIndex='0'
                  rowSpan='1'
                  colSpan='1'
                  style={{ width: "257.8px" }}
                  aria-label='Email: activate to sort column ascending'
                >
                  Detail Description
                </th>
              </tr>
            </thead>

            <tbody>
              {details?.map((item, i) => (
                <tr key={i}>
                  <td className='text-capitalize'>{item?.cover_name}</td>
                  <td className='table-user'>{item?.rate}</td>
                  <td className='table-user'>{item?.sum_assured}</td>
                  <td className='text-dark'>
                    {parseFloat(
                      (item?.rate * item?.sum_assured) / 100
                    )?.toFixed(2)}
                  </td>
                  <td>{item?.desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
      </div>
    </div>
  );
};

export default SavingsRiskInformation;
